<template>
    <section class="form-dark">
        <mdb-row class="justify-content-center mt-5">
            <mdb-col md="3">
                <mdb-card class="card-image"
                          :style="{'backgroundImage': 'url(https://mdbootstrap.com/img/Photos/Others/pricing-table4.jpg)', 'width': '28rem'}">
                    <div class="text-white rgba-stylish-strong py-5 px-5 z-depth-4">
                        <div class="text-center">
                            <h3 class="white-text mb-5 mt-4 font-weight-bold"><strong>Mot de passe</strong> <a
                                    class="green-text font-weight-bold"><strong> Perdu</strong></a></h3>
                        </div>
                        <mdb-alert color="success" v-if="showsuccessmsg">
                            Nous venons de vous envoyer un courriel contenant les instructions pour changer votre mot de passe
                        </mdb-alert>
                        <mdb-alert color="danger" v-if="errormsg">
                            {{ errormsg }}
                        </mdb-alert>
                        <mdb-input label="Adresse courriel" type="text" class="text-white" v-model="username"/>
                        <mdb-row class="d-flex align-items-center">
                            <div class="text-center mb-3 col-md-12">
                                <mdb-btn color="success" rounded type="button" class="btn-block z-depth-1"
                                         v-on:click="lostpwdreq">Continuer
                                </mdb-btn>
                            </div>
                        </mdb-row>
                        <mdb-row class="d-flex align-items-center">
                            <div class="text-center col-md-12">
                                <a v-on:click="gotologin">Retour à la page de connexion</a>
                            </div>
                        </mdb-row>
                    </div>
                </mdb-card>
            </mdb-col>
        </mdb-row>
    </section>
</template>

<script>
    import {
        mdbRow, mdbCol, mdbInput, mdbBtn, mdbCard, mdbAlert,
    } from 'mdbvue';

    import Apicall from '../libs/Apicall';

    export default {
        name: 'FormsPage',
        data() {
            return {
                username: '',
                errormsg: '',
                showsuccessmsg: false,
            };
        },
        components: {
            mdbRow,
            mdbCol,
            mdbInput,
            mdbBtn,
            mdbCard,
            mdbAlert,
        },
        methods: {
            lostpwdreq() {
                const api = new Apicall();
                const self = this;
                api.lostPasswordRequest(this.username).then((response) => {
                    self.errormsg = '';
                    if (response.status === 'OK') {
                        self.showsuccessmsg = true;
                    } else {
                        self.errormsg = response.msg;
                    }
                });
            },
            gotologin() {
                this.$router.push({ path: '/login' });
            },
        },
    };
</script>

<style>
    .form-dark .font-small {
        font-size: 0.8rem;
    }

    .form-dark input, .form-dark input:focus {
        color: #fff;
    }

    .form-dark [type="radio"] + label,
    .form-dark [type="checkbox"] + label {
        font-size: 0.8rem;
    }

    .form-dark [type="checkbox"] + label:before {
        top: 2px;
        width: 15px;
        height: 15px;
    }

    .form-dark .md-form label {
        color: #fff;
    }

    .form-dark input[type=text]:focus:not([readonly]) {
        border-bottom: 1px solid #00C851;
        -webkit-box-shadow: 0 1px 0 0 #00C851;
        box-shadow: 0 1px 0 0 #00C851;
    }

    .form-dark input[type=text]:focus:not([readonly]) + label {
        color: #fff;
    }

    .form-dark input[type=password]:focus:not([readonly]) {
        border-bottom: 1px solid #00C851;
        -webkit-box-shadow: 0 1px 0 0 #00C851;
        box-shadow: 0 1px 0 0 #00C851;
    }

    .form-dark input[type=password]:focus:not([readonly]) + label {
        color: #fff;
    }

    .form-dark input[type="checkbox"] + label:before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 17px;
        height: 17px;
        z-index: 0;
        border: 1.5px solid #fff;
        border-radius: 1px;
        margin-top: 2px;
        -webkit-transition: 0.2s;
        transition: 0.2s;
    }

    .form-dark input[type="checkbox"]:checked + label:before {
        top: -4px;
        left: -3px;
        width: 12px;
        height: 22px;
        border-style: solid;
        border-width: 2px;
        border-color: transparent #00c851 #00c851 transparent;
        -webkit-transform: rotate(40deg);
        -ms-transform: rotate(40deg);
        transform: rotate(40deg);
        -webkit-backface-visibility: hidden;
        -webkit-transform-origin: 100% 100%;
        -ms-transform-origin: 100% 100%;
        transform-origin: 100% 100%;
    }

    .form-dark .md-form input[type="text"]:not(.browser-default):focus:not([readonly]) + label, .form-dark .md-form input[type="password"]:not(.browser-default):focus:not([readonly]) + label {
        color: #fff;
    }
</style>
